import { formatDate, parseDate } from '../common';
import { ICsaRequestStatus } from '.';
import { pathOr, identity } from 'rambda';
import { replace as lreplace } from 'lodash/fp';
import { flow } from 'fp-ts/function';

export const showCsa = (value: keyof ICsaRequestStatus) =>
  flow(pathOr('', value), flow(pathOr(identity, value)(showProperty)));

const showProperty = {
  status: lreplace(/_/g, ' '),
  deaExpdt: flow(parseDate, formatDate),
  createdAt: flow(parseDate, formatDate),
  updateDatetime: flow(parseDate, formatDate),
};
